
import { Options, Vue } from "vue-class-component";
import Input from "@/app/ui/components/input/index.vue";
import router from "@/app/ui/router";
import { ExchangeRateController } from "@/app/ui/controllers/ExchangeRateController";
import { formatDateNumber } from "@/app/infrastructures/misc/Utils";
import formatInputMoneyWithDecimal from "@/app/infrastructures/misc/common-library/FormatInputMoneyWithDecimal";
import { LocationController } from "@/app/ui/controllers/LocationController";
import debounce from "lodash/debounce";
import SelectSearchV2 from "@/app/ui/components/select-search/index.vue";
import { CountryData } from "@/domain/entities/Location";

@Options({
  components: {
    Input,
    SelectSearchV2
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (this.hasChanged && !this.openSuccess) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      ExchangeRateController.setOpenModalSuccess(false);
      this.name = "";
      next();
    }
  },
  watch: {
    // Re-derive the raw rate under the previous currency's locale, then
    // reformat under the new one — the displayed string's decimal/thousand
    // separators are currency-locale-specific (e.g. IDR uses "," as decimal,
    // USD uses "."), so leaving it as-is after a currency switch silently
    // reinterprets the value under the wrong locale.
    kursTukarValue(_newValue: string, oldValue: string) {
      if (!this.exchangeRateValue) {
        return;
      }
      this.exchangeRateValue = String(
        formatInputMoneyWithDecimal(this.exchangeRateValue, 6, oldValue, {
          reset: true
        })
      );
      this.formatted();
    }
  }
})
class Add extends Vue {
  goBack() {
    this.$router.back();
  }

  mounted() {
    ExchangeRateController.setErrorValidation(false);
    this.fetchCountryCurrency("");
  }

  // filter kurs awal
  kursAwalSelect = false;
  kursAwal: any = "";
  onSelectKursAwal(object: any) {
    this.kursAwal = object;
  }

  // kurs awal select
  resetSelectSearch = 0;
  fetchCountryCurrency = debounce((search: string) => {
    const q = search.includes("-") ? search.split("-")?.[0] : search;

    LocationController.getCountryList({
      search: q.trim(),
      status: "active",
      page: 1,
      limit: 10
    });
  }, 250);

  get isLoadingCountry() {
    return LocationController.isLoadingCountry;
  }

  get countryListData() {
    return LocationController.countryData.countryData.map((e: CountryData) => ({
      label: `${e.name} - ${e.currency}`,
      name: e.name,
      value: e.currency
    }));
  }

  // filter kurs tukar
  kursTukar: any = "";
  onSelectKursTukar(object: any) {
    this.kursTukar = object;
  }
  get kursTukarValue() {
    return this.kursTukar?.value || "";
  }

  // client-side guard: kurs awal !== kurs tukar
  get isSameCurrency() {
    return (
      !!this.kursAwal?.value &&
      !!this.kursTukarValue &&
      this.kursAwal.value === this.kursTukarValue
    );
  }

  // Modal Success
  messageSuccess = "";
  get openSuccess() {
    return ExchangeRateController.openModalSuccess;
  }
  onCloseSuccess() {
    router.push(`/tarif/exchange-rate`);
  }

  // Save data
  get openSave() {
    return ExchangeRateController.openModal;
  }
  onOpenSave() {
    ExchangeRateController.setOpenModal(true);
  }
  onCloseSave() {
    ExchangeRateController.setOpenModal(false);
  }
  _onCreate() {
    this.onCloseSave();
    ExchangeRateController._onAddExchangeRate({
      from: this.kursAwal?.value,
      to: this.kursTukarValue,
      exchangeRate: Number(
        formatInputMoneyWithDecimal(
          this.exchangeRateValue,
          6,
          this.kursTukarValue,
          {
            reset: true
          }
        )
      ),
      effectiveDate: formatDateNumber(this.effectiveDate)
    });
  }

  // Close when changed
  isEditTerminated = false;
  newPath = "";
  answer = false;

  get hasChanged() {
    return this.kursAwal !== "" || this.kursTukar !== "";
  }

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  exchangeRateValue: any = 0;

  formatted() {
    this.exchangeRateValue = formatInputMoneyWithDecimal(
      this.exchangeRateValue,
      6,
      this.kursTukarValue
    );
  }

  get isRateValueInvalid() {
    const parsed = Number(
      formatInputMoneyWithDecimal(
        this.exchangeRateValue,
        6,
        this.kursTukarValue,
        {
          reset: true
        }
      )
    );
    return !parsed || parsed <= 0;
  }

  // disable
  get isDisabled() {
    return (
      !this.kursAwal ||
      !this.kursTukarValue ||
      this.isRateValueInvalid ||
      this.isSameCurrency ||
      !this.effectiveDate
    );
  }

  //Error
  get isError() {
    return ExchangeRateController.isError;
  }

  get isErrorValidation() {
    return ExchangeRateController.isErrorValidation;
  }

  get errorMessage() {
    return ExchangeRateController.errorMessage;
  }

  //Error Cause
  get errorCause() {
    return ExchangeRateController.errorCause;
  }

  handleErrorClose() {
    ExchangeRateController.handleError();
  }

  // Date
  effectiveDate: Date | null = null;
  get minDate() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  inputEffectiveDate(param: Date) {
    this.effectiveDate = param;
  }

  // check online status
  online = window.navigator.onLine;
}

export default Add;
